import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseEmailTemplatesComponent, TemplateParameters } from '../../base-email-templates-landing-page.component';
import { AssetsUserDetailsService, FirearmAssignmentService, FirearmService, TransferAssetService } from 'assets-service';


@Component({
  selector: 'firearm-maintenance-notification-email-templates',
  templateUrl: './firearm-maintenance-notification-email-template.component.html',
  styleUrls: ['./firearm-maintenance-notification-email-template.component.scss']
})
export class FirearmMaintenanceNotificationEmailTemplatesComponent extends BaseEmailTemplatesComponent {

  constructor(private firearmService: FirearmService) {
    super();
  }

  protected getExampleTemplateParameters(backgroundServiceCall?: boolean): Observable<TemplateParameters> {
    return this.firearmService.exampleMaintenanceNotificationTemplateParameters(backgroundServiceCall);
  }


}
